document.addEventListener('DOMContentLoaded', function () {
  const colorButtons = document.querySelectorAll('.swatch');

  colorButtons.forEach(button => {
    button.addEventListener('click', function () {
      const imageUrl = this.getAttribute('data-img');
      const parentWrapper = this.closest('.product-card-wrapper');
      const mainImage=parentWrapper.querySelector('.main-image')

      if (mainImage && imageUrl) { // 确保mainImage和imageUrl都存在
        mainImage.setAttribute('src',imageUrl)
        mainImage.setAttribute('srcset',imageUrl)
      }
    });
  });
});